export class TauxFraisInput
{
    codeTypeCredit: String;
    employeur: String;
    montantDemande: number;
    salaireEmprunteur: number;
    montantLoyer: number;
    primeTrimestrielle: number;
    echeanceMois: number;
    codeProduit: String;
    typeVirementPermant: String;
}